import { Loading } from '@ferreri/prever-component-lib';
import { useHasBenefit } from 'modules/contract/contract.store';
import { PetCremationBenefit } from './PetCremationBenefit';
import { PetCremationBenefitContractEmptyState } from './PetCremationBenefitContractEmptyState';
import { PetCremationBenefitEmptyState } from './PetCremationBenefitEmptyState';

export const PetCremationHasBenefit = () => {
  const query = useHasBenefit();

  if (query?.isLoading) {
    return <Loading />;
  }

  if (!query?.data?.contract_active?.is_valid && !query?.data?.allowed_usage) {
    return <PetCremationBenefitContractEmptyState />;
  }

  if (query?.data?.allowed_usage) {
    return <PetCremationBenefit />;
  }

  return <PetCremationBenefitEmptyState />;
};
